// src/contexts/config.ts

export const SYSTEM_CONFIG = {
  raffle: {
    raffleWord: {
      ticket: {
        price: { min: 0.01, max: 9999999 },
        quantity: { min: 10, max: 9999999 },
      },
    },

    raffleNumber: {
      ticket: {
        price: { min: 0.01, max: 9999999 },
        quantity: { min: 10, max: 9999999 },
      },
    },
  },

  user: {
    maxImageSize: 5,
    maxLoginAttempts: 5,
    lockoutDuration: 30,
  },

  system: {
    pageSize: 20,
    apiTimeout: 30000, // ms
    cacheTime: 3600, // segundos
  },

  notification: {
    emailEnabled: true,
    pushEnabled: true,
  },
};

// --- Get the value with Fallback --- //
export const getConfigValue = (path: string, fallback?: any) => {
  const keys = path.split(".");
  let value = SYSTEM_CONFIG as any;

  for (const key of keys) {
    value = value?.[key];
  }

  return value !== undefined ? value : fallback;
};

// Example:
// SYSTEM_CONFIG.ticket.price.min
// getConfigValue('ticket.price.min', 0.01)
// getConfigValue('user.maxImageSize', 5)
